import * as React from 'react';
import * as styles from './styles.css';
import { clsx } from 'clsx';

export const AiModalSkeleton = (): React.JSX.Element => {
  return (
    <div className={styles['container']}>
      <div className={clsx(styles['stub'], styles['first-stub'])} />
      <div className={clsx(styles['stub'], styles['first-stub'])} />
      <div className={clsx(styles['stub'], styles['second-stub'])} />
    </div>
  );
};
